var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isUploaderSetting
    ? _c(
        "div",
        [
          _c("q-uploader", {
            ref: _vm.uploadRef,
            staticClass: "table-upload uploadColumn",
            style: _vm.maxheight,
            attrs: {
              flat: "",
              "with-credentials": "",
              capture: "environment",
              "field-name": "file",
              url: _vm.url,
              headers: _vm.headers,
              method: "POST",
              label: _vm.convertLabel,
              "form-fields": _vm.formFields,
              "auto-upload": false,
              "hide-upload-btn": true,
              multiple: _vm.setting.multipleSelFlag === "Y",
              accept: _vm.setting.acceptExt,
              "max-file-size": _vm.setting.limitSize * 1000000,
              "max-total-size":
                _vm.setting.limitSize * 1000000 * _vm.setting.limitCnt,
              "max-files": _vm.maxFiles,
              "no-thumbnails": _vm.setting.previewFlag === "Y",
              disable: !_vm.editable,
            },
            on: {
              added: _vm.added,
              finish: _vm.finish,
              failed: _vm.failed,
              rejected: _vm.rejected,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "row no-wrap items-center q-pa-none q-gutter-xs",
                        },
                        [
                          scope.isUploading
                            ? _c("q-spinner", {
                                staticClass: "q-uploader__spinner",
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "col no-margin" }),
                          _c(
                            "q-icon",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.editable && _vm.maxFiles > 0,
                                  expression: "editable && maxFiles > 0",
                                },
                              ],
                              staticClass: "no-margin cursor-pointer",
                              attrs: { name: "add", size: "xs" },
                            },
                            [
                              _c("q-uploader-add-trigger"),
                              _c("q-tooltip", [_vm._v("파일 선택하기")]),
                            ],
                            1
                          ),
                          _c(
                            "q-icon",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.haveImage(),
                                  expression: "haveImage()",
                                },
                              ],
                              staticClass: "no-margin cursor-pointer",
                              attrs: { name: "visibility", size: "xs" },
                              on: { click: _vm.allImagePreView },
                            },
                            [_c("q-tooltip", [_vm._v("이미지 파일 미리보기")])],
                            1
                          ),
                          _c(
                            "q-icon",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.fileList &&
                                    _vm.fileList.length > 0,
                                  expression:
                                    "editable && fileList && fileList.length > 0",
                                },
                              ],
                              staticClass: "no-margin cursor-pointer",
                              attrs: { name: "delete_outline", size: "xs" },
                              on: { click: _vm.removeAllFiles },
                            },
                            [_c("q-tooltip", [_vm._v("파일 전체 삭제")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "list",
                  fn: function (scope) {
                    return [
                      scope.files && scope.files.length > 0
                        ? [
                            _c(
                              "q-list",
                              { attrs: { separator: "" } },
                              _vm._l(scope.files, function (file) {
                                return _c(
                                  "q-item",
                                  { key: file.name },
                                  [
                                    _c(
                                      "q-item-section",
                                      [
                                        _c(
                                          "q-item-label",
                                          {
                                            staticClass: "full-width ellipsis",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " Status: " +
                                                _vm._s(file.__status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(file.__sizeLabel) +
                                                " / " +
                                                _vm._s(file.__progressLabel) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "empty_dscription" },
                              [_c("q-uploader-add-trigger")],
                              1
                            ),
                          ],
                    ]
                  },
                },
              ],
              null,
              false,
              912983181
            ),
          }),
          _vm.fileList && _vm.fileList.length > 0
            ? _c(
                "q-list",
                {
                  staticClass: "uploaded-file-list-table",
                  attrs: { separator: "" },
                },
                _vm._l(_vm.fileList, function (file, idx) {
                  return _c(
                    "q-item",
                    { key: idx },
                    [
                      _c(
                        "q-item-section",
                        [
                          _c(
                            "q-item-label",
                            { staticClass: "table-file-origin-name" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-blue cursor-pointer table-ellipsis",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.fileDown(file)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(file.oriFileNm) + " "),
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "bottom left",
                                        self: "top left",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(file.oriFileNm) + " ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "q-item-section",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                file.contentType &&
                                file.contentType.indexOf("image") > -1,
                              expression:
                                "file.contentType && file.contentType.indexOf('image') > -1",
                            },
                          ],
                          staticClass: "gt-xs cursor-pointer",
                          attrs: { thumbnail: "" },
                        },
                        [
                          _c("img", {
                            staticClass: "thumnailUpload",
                            attrs: {
                              src: file.imgUrl ? file.imgUrl : file.filePath,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.setPreview(file, "single")
                              },
                            },
                          }),
                        ]
                      ),
                      _c(
                        "q-item-section",
                        { attrs: { top: "", side: "" } },
                        [
                          _vm.editable
                            ? _c(
                                "q-btn",
                                {
                                  staticClass: "gt-xs",
                                  attrs: {
                                    size: "12px",
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    icon: "delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.removeFile(file)
                                    },
                                  },
                                },
                                [_c("q-tooltip", [_vm._v("파일 삭제")])],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.preview &&
          (_vm.preview.src ||
            (_vm.preview.fileList && _vm.preview.fileList.length > 0))
            ? _c(
                "q-dialog",
                {
                  model: {
                    value: _vm.preview.isShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.preview, "isShow", $$v)
                    },
                    expression: "preview.isShow",
                  },
                },
                [
                  _c(
                    "q-card",
                    { staticClass: "preview-image-card" },
                    [
                      _c(
                        "q-icon",
                        {
                          staticClass: "preview-close-btn cursor-pointer",
                          attrs: { color: "grey-8", size: "sm", name: "close" },
                          on: {
                            click: function ($event) {
                              _vm.preview.isShow = false
                            },
                          },
                        },
                        [_c("q-tooltip", [_vm._v("창닫기")])],
                        1
                      ),
                      _vm.preview.fileList && _vm.preview.fileList.length > 0
                        ? _c(
                            "q-carousel",
                            {
                              attrs: {
                                swipeable: "",
                                animated: "",
                                thumbnails: "",
                                infinite: "",
                              },
                              on: { transition: _vm.transitionImage },
                              model: {
                                value: _vm.preview.slide,
                                callback: function ($$v) {
                                  _vm.$set(_vm.preview, "slide", $$v)
                                },
                                expression: "preview.slide",
                              },
                            },
                            _vm._l(_vm.preview.fileList, function (file, idx) {
                              return _c("q-carousel-slide", {
                                key: idx,
                                attrs: {
                                  name: file.sysAttachFileId,
                                  "img-src": file.src,
                                },
                              })
                            }),
                            1
                          )
                        : _c("q-img", { attrs: { src: _vm.preview.src } }),
                      _c(
                        "q-card-section",
                        { staticClass: "text-right" },
                        [
                          _c("span", { staticClass: "text-h6" }, [
                            _vm._v(" " + _vm._s(_vm.preview.oriFileNm) + " "),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-grey text-caption q-pt-md no-wrap",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFileSizeTextByRound(
                                      _vm.preview.fileSize
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("q-icon", {
                            staticClass: "cursor-pointer q-ml-xs",
                            attrs: {
                              color: "blue",
                              size: "sm",
                              name: "save_alt",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.fileDown(_vm.preview)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }